import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Space, Row, Select } from "@masterteam/mt-design-react";

import KPIList from "../KPIList";
import ObjectivesList from "../ObjectivesList";
import InitiativesList from "../InitiativesList";
import ProjectsList from "../ProjectsList";

import { useIsAr } from "../../Hooks";

import { ReactComponent as KPIsIcon } from "../../assets/images/objectives-icon.svg";
import { ReactComponent as ProjectsIcon } from "../../assets/images/initiative-icon.svg";
import { ReactComponent as ObjectivesIcon } from "../../assets/images/level-two.svg";

import "./style.scss";

const ListsContainer = ({
  kpiStatuses,
  projectStatuses,
  kpiTypes,
  objective,
  orgStructure,
  isSupportive,
  allProjectStatuses
}) => {
  const [isAr] = useIsAr();
  const [selectedSectors, setSelectedSectors] = useState([]);

  const tabs = [
    {
      ID: 1,
      name: "common.strategic-kpis",
      value: "kpis",
      icon: <KPIsIcon />,
      showItem: true,
      component: () => (
        <KPIList items={objective?.KPIs || []} kpiTypes={kpiTypes} />
      ),
      length: objective?.KPIs?.length || 0,
    },
    {
      ID: 2,
      name: isSupportive ? "common.strategic-initiatives":"common.strategic-projects",
      value: "projects",
      icon: <ProjectsIcon />,
      showItem: true,
      component: () => (
        isSupportive ? <InitiativesList 
        initiatives={objective?.Initiatives || []}
        initiativeStatuses={projectStatuses}
        projectStatuses={allProjectStatuses}
        />: <ProjectsList
          projects={objective?.Projects || []}
          projectStatuses={projectStatuses}
        />
      ),
      length: isSupportive ? objective?.Initiatives?.length : objective?.Projects?.length || 0,
    },
    {
      ID: 3,
      name: "common.strategic-objectives-level2",
      value: "objectives",
      icon: <ObjectivesIcon style={{ width: 18 }} />,
      showItem: +objective.Level === 1,
      component: (selectedSectors) => (
        <ObjectivesList
          items={objective?.Objectives || []}
          statuses={kpiStatuses}
          projectStatuses={projectStatuses}
          selectedSectors={selectedSectors}
        />
      ),
      length: objective?.Objectives?.length || 0,
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <Space direction="vertical" size="medium" className="animated slIDeInRight">
      <Row
        justify="between"
        align="center"
        className="strategic-kpis-container_header"
      >
        <Space gap={0}>
          {tabs
            .filter((e) => e.showItem)
            .map((item) => (
              <Space
                key={item.ID}
                onClick={() => {
                  setActiveTab(item);
                  setSelectedSectors([]);
                }}
                className={`tab-item cursor ${
                  activeTab.value === item.value && "active"
                }`}
              >
                {item.icon}
                <FormattedMessage id={item.name} /> ({item.length})
              </Space>
            ))}
        </Space>

        {activeTab.value === "objectives" ? (
          <div className="sectors-wrapper">
            <FormattedMessage id="common.sectors" />

            <Select
              options={orgStructure}
              menuPlacement="top"
              placeholder={<FormattedMessage id="common.select" />}
              getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
              getOptionValue={(el) => el?.ID}
              onChange={(item) => {
                setSelectedSectors(item);
              }}
              value={selectedSectors}
              isMulti
            />
          </div>
        ) : null}
      </Row>

      {activeTab.component(selectedSectors)}
    </Space>
  );
};

export default ListsContainer;
